import DimensionListReviewerDialog from './DimensionListReviewerDialog';

export default DimensionListReviewerDialog;
